import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AUTO_DRAFT_STATE_KEY } from './auto-draft.key';
import { AutoDraftEntities } from './auto-draft.model';

export const selectAutoDraft = createFeatureSelector<AutoDraftEntities>(AUTO_DRAFT_STATE_KEY);

export const selectAutoDraftsByAccountNumber = createSelector(selectAutoDraft, s => s?.entities);
export const selectAutoDrafts = createSelector(
    selectAutoDraft,
    s => s?.ids.map(id => s.entities[id]!)
);

export const selectAutoDraftsLoaded = createSelector(selectAutoDraft, s => s?.loaded);
